// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"efa32fe1","779":"d4cee896"}[chunkId] + ".chunk.js";
};